module.exports = __webpack_public_path__ + "static/Contact_img-a04e8162332304abb310f64ed7427590.png";